export enum InvoiceViewType {
  NONE = "none",
  REJECTED = "rejected",
  DISPATCHED = "dispatched",
  SEARCH = 'search',
  VOUCHERWORKFLOW = 'voucherworkflow',
  VOUCHERVALIDATED = 'vouchervalidated',
  CONTROL = 'control',
  INJECTION = 'injection',
  WAITING = 'waiting-voucher',
  PROMOTIONWORKFLOW = 'promotionworkflow',
  MANUAL = "manual",
}
